import React,{ useState, useRef , useEffect} from 'react';
import { withRouter } from 'react-router';
import {callGET} from '../../../Utils/ApiUtil';
import * as ShipConstants from '../../../Global/Constants';
import {getWindowDataUsingId} from '../../../Utils/CommonFunctions';

const TopSearch = props => {
	const [isSearching,setIsSearching] = useState(false);
	const KeyCodes = {
	    comma: 188,
	    enter: 13,
	};
  const delimiters = [KeyCodes.enter];
  
	const [data,setData] = useState({
		searchTag : false,
		searchText : '',
		tagsList : []
	})
	const searchRequestId = useRef(0);
	const pendingRequests = useRef(0);

	useEffect(() => {
	const pathName = props.location.pathname;

	// If user navigates away from tag routes
	if (!pathName.includes('/tags/')) {
		setData(prev => ({
			...prev,
			searchText: '',
			searchTag: false,
			tagsList: []
		}));
	}
}, [props.location.pathname]);
	const toggleSearchTag = (status) => {
		if (status === false) {
			searchRequestId.current++;
			pendingRequests.current = 0;
			setIsSearching(false);
		}
		setData(prev => ({
			...prev,
			searchTag: status,
			...(status === false && { searchText: '', tagsList: [] })
		}));
	}

	const searchTagHandler = (keyword = data.searchText) => {
		const requestId = ++searchRequestId.current;
		pendingRequests.current++;
		setIsSearching(true);
		const API_URL = "tag-mapping/search-tags?searchKeyword="+keyword+"&paginator.orderBy=tag_name&paginator.sortAsc=true&paginator.page=0&paginator.size=30";

	 	callGET(API_URL)
        .then(response => {
			pendingRequests.current--;
			if (pendingRequests.current === 0) setIsSearching(false);
			if (requestId !== searchRequestId.current) return;
        	const responseData = response.data;
        	if(responseData.code === ShipConstants.API_STATUS_SUCCESS) { 
        		setData(prev => {
					if (!prev.searchTag) return prev;
					return {
						...prev,
						tagsList: responseData.data ? responseData.data.content : []
					};
				});
        	}
        })
        .catch(err => {
			pendingRequests.current--;
			if (pendingRequests.current === 0) setIsSearching(false);
			if (requestId !== searchRequestId.current) return;
          console.log(err);
        });
	}

	const openAndSearch = () => {
		if (!data.searchTag) {
			setData(prev => ({ ...prev, searchTag: true }));
		}
		searchTagHandler(data.searchText);
	}

	const selectTagsHandler = (val) => {
		const tagsData = JSON.parse(val);
		console.log(val);
		setData(prev => ({
  ...prev,
  searchText: '',
  searchTag: false
}));
		// toggleSearchTag(false);
		
		if(tagsData.windows) {
			let url = "";//"/tags/"+tagsData.id;
			if(tagsData.windows.length>0) {
				const wind = tagsData.windows[0];
				const data = getWindowDataUsingId(wind.id);
				
				url = "/layouts/"+wind.display_name+"/"+wind.id+"/list/"+data.layout_id+'/tags/'+tagsData.id;
			}
			console.log(url);
			if(url !== '') {
				props.globalSearch(val);
				props.history.push(url);	
			}else {
				props.warningMessage("Tag: <span class='text-danger'>"+tagsData.tag_name+"</span> not found in any window");
			}
		}else {
			props.warningMessage("Tag: <span class='text-danger'>"+tagsData.tag_name+"</span> not found in any window");
		}
		
		
	}


	const changeHandler = (e) => {
		const {name,value} = e.target;
		setData(prev => ({
  ...prev,
  [name]: value
}));
	}

	const handleKeyDown = (event) => {   
      // console.log("test");     
      if (delimiters.indexOf(event.keyCode) !== -1 ) {
          openAndSearch();
      }
  }
  let searchHeaderClassName = 'collapse';
  let searchHeaderCss = {position: "relative"};
  if(props.isMobileView===true){
	searchHeaderClassName = 'collapse topSearch_MobileView';
	searchHeaderCss = {display:(props.isSearchVisible===true)?'':'none'}
	// console.log('props.isSearchVisible',props.isSearchVisible);
  }
	
	return (
		<div className={searchHeaderClassName} tabIndex='1' id="search-nav" style={{...searchHeaderCss}}>
						<div className="input-group">
							  {(props.isMobileView===true)?
							  	<div className="input-group-prepend">
								  <a className="btn border-default btn-border" onClick={()=>props.setSearchVisible(false)} id="closeSearch"> <i className="fas fa-times fa-lg"></i> </a>
							  	</div>
							  :''}
				  
              	<input 
              		type="text" 
              		name="searchText"
              		className="form-control form-control-sm topSearch" 
              		placeholder="Search by Tags" 
              		autoComplete="off" 
              		onKeyDown={handleKeyDown}
					onFocus={() => {
						if (!data.searchTag) openAndSearch();
					}}
              		value={data.searchText}
              		onChange={changeHandler}
              	/>
				{(isSearching===true) &&
                  <i
                    className="fas fa-spinner fa-spin fa-lg"
                    style={{
                      position: "absolute",
                      top: "35%",
                      right: "80px", // Adjust based on your padding
                      transform: "translateY(-50%)",
                      color: "#000", // Customize loader color
                      zIndex: '999'
                    }}></i>
                }
              
              	<div className="input-group-append">
                	<a className="btn primary_bg " onClick={openAndSearch} style={{padding:'7px 13px'}}>
                		Search
                	</a>
              	</div>

            </div>

{data.searchTag && (
  <>
    {/* Backdrop */}
    <div 
      className="backdrop" 
      onClick={() => toggleSearchTag(false)}
    ></div>

    {/* Modal */}
    <div 
      className="overallSearch_bg"
      onClick={(e) => e.stopPropagation()}
    >
      
      <div className="search_Header">
        <h6 className="mb-0"> List of Tags </h6>
        <div className="close" onClick={() => toggleSearchTag(false)}> 
          <i className="fas fa-times"></i> 
        </div>
      </div>

      <div className="search_Body">
        {
          isSearching && data.tagsList.length === 0 ?
            <p>Loading...</p>
          : data.tagsList.length > 0 ?
              data.tagsList.map((arr,ind) => {
                const tagData = JSON.stringify(arr);
                return (
                  <div key={ind} className="tagContent" onClick={() => selectTagsHandler(tagData)}>
                    <div className="tagInner">
                      <div className="tagInnerWid">
                        <label className="taglabel"> 
                          <div className="tagText" title={arr.tag_name} > {arr.tag_name} </div>
                        </label>
                      </div>
                    </div>
                  </div>
                )
              })
            : <p>No records found</p>
        }
      </div>  

    </div>
  </>
)}
			<div className="input-group hide">
				<div className="input-group-prepend">
					<button className="btn btn-search pr-1"><i className="fa fa-search primary_color"></i>&nbsp;<i className="fas fa-caret-down primary_color"></i>
					</button>
				</div>
				<input type="text" placeholder="Search by All" className="form-control third_light_color" />
			</div>
		</div>
	);
}

export default withRouter(TopSearch);